// Section scrolling helpers that cooperate with Lenis smooth scrolling.

export function scrollToId(id, offset = -84) {
  if (id === "top") {
    if (window.__lenis) window.__lenis.scrollTo(0, { offset: 0 });
    else window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset });
  } else {
    const y = el.getBoundingClientRect().top + window.scrollY + offset;
    window.scrollTo({ top: y, behavior: "smooth" });
  }
}
